"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const rich_text_1 = require("@vedalib/rich-text");
const md_utils_1 = require("../../../export/md.utils");
const toMarkdown = (element, context) => {
    var _a;
    if (!((_a = element.value) === null || _a === void 0 ? void 0 : _a.items) || element.value.items.length === 0) {
        return '';
    }
    const { items, mode } = element.value;
    const isOrdered = mode === 'number';
    const listItems = items
        .map((item, index) => {
        var _a;
        let content = item.label
            ? (0, rich_text_1.slateToMarkdown)(item.label, {
                allowHtmlStyles: context.withStyle,
                allowAlignment: context.withStyle,
                allowCaptionHtml: context.withStyle,
            }).trim()
            : '';
        content = (0, md_utils_1.sanitizeInlineMd)(content);
        if (!content) {
            return '';
        }
        if (isOrdered) {
            const number = (_a = item.number) !== null && _a !== void 0 ? _a : index + 1;
            return `${number}. ${content}`;
        }
        return `- ${content}`;
    })
        .filter(Boolean);
    if (listItems.length === 0) {
        return '';
    }
    return listItems.join('\n') + '\n\n';
};
exports.toMarkdown = toMarkdown;
